import { styled } from '@mui/material/styles';

import { GatsbyImage } from 'gatsby-plugin-image';

const commonStyles = ({ theme }) => `
  max-height: 320px;
  width: 100%;
  + p, + span {
   margin-top: ${theme.DS_spacing(['md'])};
  }

  ${theme.breakpoints.up('md')} {
    max-height: 520px;
    + p,  + span  {
     margin-top: ${theme.DS_spacing(['lg'])};
    }
      
  }
`;

const StyledGatsbyImage = styled(GatsbyImage)`
  ${commonStyles};
`;

const StyledSvg = styled('svg')`
  ${commonStyles};
`;

export { StyledGatsbyImage, StyledSvg };
